<template>
  <vue-progress-bar></vue-progress-bar>
</template>

<script>
export default {
  name: 'notification',
  computed: {
    progress () {
      return this.$store.state.progress
    },
    notification () {
      return this.$store.state.notification
    }
  },
  watch: {
    progress (newValue, oldValue) {
      if (newValue > 0 && oldValue > 0) {
        // Just continue loading
        return
      }

      if (newValue > 0) {
        this.$Progress.start()
      }
      else {
        setTimeout(() => {
          if (newValue <= 0) {
            this.$Progress.finish()
          }
        }, 400)
      }
    },
    notification ({ type, message }) {
      let notify = this.$notify.error

      if (type === 'success') {
        notify = this.$notify.success
      }
      else if (type === 'warning') {
        notify = this.$notify.warning
      }
      else if (type === 'info') {
        notify = this.$notify.info
      }

      // TODO: Handle message and title
      // http://element.eleme.io/#/en-US/component/notification#options
      notify({ title: this.$t(message) })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Notification.vue?3f9a5dcc